export default __webpack_public_path__ + "static/1_27-1--80ffc7c31594fee591556833069ad899.png";